import React, { useState } from 'react';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import { FiLock, FiEye, FiEyeOff, FiCheckCircle, FiArrowLeft } from 'react-icons/fi';
import { toast } from 'react-toastify';
import api from '../services/api';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!password || !confirmPassword) {
      toast.error("Veuillez remplir tous les champs.");
      return;
    }

    if (password.length < 6) {
      toast.error("Le mot de passe doit contenir au moins 6 caractères.");
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas.");
      return;
    }
    
    if (!token) {
      toast.error("Jeton de réinitialisation manquant ou invalide.");
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success("Mot de passe réinitialisé avec succès ! Vous pouvez maintenant vous connecter.");
      navigate('/login');
    } catch (error) {
      toast.error(error.response?.data?.message || "Le lien de réinitialisation est invalide ou a expiré.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md bg-white p-8 lg:p-10 rounded-2xl shadow-xl border border-gray-100">
        <div className="text-center mb-10">
          <h2 className="text-3xl font-bold font-poppins text-gray-900 tracking-tight">Réinitialiser le mot de passe</h2>
          <p className="text-gray-500 mt-2 text-lg">Choisissez un nouveau mot de passe sécurisé.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="password" class="block text-sm font-bold text-gray-700 mb-2 ml-1">Nouveau mot de passe</label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-brand-blue transition-colors">
                <FiLock size={20} />
              </div>
              <input
                className="w-full pl-11 pr-12 py-3.5 rounded-xl bg-gray-50 border border-gray-100 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue focus:bg-white transition-all duration-200"
                id="password"
                type={showPassword ? "text" : "password"} 
                placeholder="••••••••"
                value={password} onChange={(e) => setPassword(e.target.value)}
              />
              <div className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <FiEyeOff className="text-gray-500 hover:text-brand-blue transition-colors" /> : <FiEye className="text-gray-500 hover:text-brand-blue transition-colors" />}
              </div>
            </div>
          </div>

          <div>
            <label htmlFor="confirmPassword" class="block text-sm font-bold text-gray-700 mb-2 ml-1">Confirmer le mot de passe</label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none text-gray-400 group-focus-within:text-brand-blue transition-colors">
                <FiLock size={20} />
              </div>
              <input
                className="w-full pl-11 pr-12 py-3.5 rounded-xl bg-gray-50 border border-gray-100 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-brand-blue/20 focus:border-brand-blue focus:bg-white transition-all duration-200"
                id="confirmPassword"
                type={showConfirmPassword ? "text" : "password"} 
                placeholder="••••••••"
                value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <div className="absolute top-1/2 right-4 -translate-y-1/2 cursor-pointer" onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
                {showConfirmPassword ? <FiEyeOff className="text-gray-500 hover:text-brand-blue transition-colors" /> : <FiEye className="text-gray-500 hover:text-brand-blue transition-colors" />}
              </div>
            </div>
          </div>

          <button 
            disabled={loading} 
            className="w-full flex justify-center items-center py-4 px-4 border border-transparent rounded-xl shadow-lg shadow-brand-green/20 text-base font-bold text-white bg-brand-green hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-green transition-all duration-200 transform hover:-translate-y-0.5 disabled:opacity-75 disabled:cursor-not-allowed" 
            type="submit"
          >
            {loading ? 'Enregistrement...' : (
              <>
                <FiCheckCircle className="mr-2" /> Enregistrer le mot de passe
              </>
            )}
          </button>

          <p className="text-center text-sm mt-8">
            <Link to="/login" className="font-bold text-brand-blue hover:text-blue-700 transition-colors flex items-center justify-center"><FiArrowLeft className="mr-2" /> Retour à la connexion</Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;